module.exports = __webpack_public_path__ + "img/@logo_kgc@3x.0637118a.png";